import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import type { ParcelamentoResponse } from "@practium/features/parcelling";

interface UseGetParcellingAllParams {
	page?: number;
	limit?: number;
	enabled?: boolean;
}

export const useGetParcellingAll = ({
	page = 1,
	limit = 200,
	enabled = true,
}: UseGetParcellingAllParams = {}) => {
	const query = useQuery({
		queryKey: ["parcelling", "all", page, limit],
		enabled,
		placeholderData: (previousData) => previousData,
		queryFn: async () => {
			const { data } = await api.get<ParcelamentoResponse>("/advices/parcelling/findAll", {
				params: { page, limit },
			});
			return data;
		},
	});

	return {
		...query,
		data: query.data?.docs ?? [],
		pagination: query.data
			? {
					totalDocs: query.data.totalDocs,
					totalPages: query.data.totalPages,
					page: query.data.page,
					hasPrevPage: query.data.hasPrevPage,
					hasNextPage: query.data.hasNextPage,
					prevPage: query.data.prevPage,
					nextPage: query.data.nextPage,
				}
			: null,
	};
};
